import { isUndefined } from 'lodash-es';
import { type PropsWithChildren, useCallback, useState } from 'react';

import { SynchronizedCrosshairContext } from '../contexts/SynchronizedCrosshair.context.js';

export const SynchronizedCrosshairProvider = ({
  children,
}: PropsWithChildren) => {
  const [hoveredTimestamp, setHoveredTimestamp] = useState<number>();
  const [hoveredChartId, setHoveredChartId] = useState<string>();
  const [disabled, setDisabled] = useState(false);

  const updateHoverState = useCallback(
    (chartId?: string, timestamp?: number) => {
      const hoveredOutside = isUndefined(timestamp);

      if (hoveredOutside) {
        setHoveredTimestamp(undefined);
        setHoveredChartId(undefined);
      } else {
        setHoveredTimestamp((prevHoveredTimestamp) =>
          prevHoveredTimestamp !== timestamp ? timestamp : prevHoveredTimestamp,
        );
        setHoveredChartId((prevHoveredChart) =>
          prevHoveredChart !== chartId ? chartId : prevHoveredChart,
        );
      }
    },
    [],
  );

  return (
    <SynchronizedCrosshairContext.Provider
      value={{
        hoveredChartId,
        hoveredTimestamp,
        updateHoverState,
        disabled,
        setDisabled,
      }}
    >
      {children}
    </SynchronizedCrosshairContext.Provider>
  );
};
